import common from './omnikadeTheme/commonStyle.oci';
import landscape from './omnikadeTheme/landscape.oci';
import portrait from './omnikadeTheme/portrait.oci';

export let commonStyles = common;
export let landscapeStyle = landscape;
export let portraitStyles = portrait;
